import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BreadCrumb } from 'src/app/models/breadcrumb.model';
import { SchoolPackageViewTile } from 'src/app/models/schoolpackageviewtile.model';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { SchoolPackageService } from 'src/app/services/school-package.service';
import { SchoolmanagementService } from 'src/app/services/schoolmanagement.service';

@Component({
  selector: 'app-module-packages',
  templateUrl: './module-packages.component.html',
  styleUrls: ['./module-packages.component.css']
})
export class ModulePackagesComponent implements OnInit {

  @Input() modulePackages: SchoolPackageViewTile[];
  @Input() embeded: boolean = false;
  breadcrumb: BreadCrumb[];
  currentUserIsAdmin: boolean;
  constructor(private schoolPackageService: SchoolPackageService, private headerinfo: ComponentheaderService, private schoolService: SchoolmanagementService, private activatedroute: ActivatedRoute) { 
    
    
  }

  async ngOnInit() {
    //debugger;
    if(!this.embeded){
      this.headerinfo.setHeaderDisplay('Loading Packages...', [], []);
      this.headerinfo.pageLoadingStarted(this);
    }
    try{
      const school: any = await this.schoolService.getSchoolFromSubdomain();
      const schooldetails: any = await this.schoolService.getSchoolDetails(school.id).toPromise();
      this.currentUserIsAdmin = schooldetails.callerIsAdmin;
      //debugger;
      this.modulePackages = await this.schoolPackageService.getSchoolPackages().toPromise();

      if(!this.embeded){
        this.breadcrumb = [
          { displaytext: "School", route: `schoolhome` },
          { displaytext: "Packages", route: this.activatedroute.snapshot.url.join('/'), params: this.activatedroute.snapshot.queryParams }
        ];
        let adminActions = [];
        if(this.currentUserIsAdmin){
          adminActions = [{ displaytext: 'Create New Package', route: 'editpackage', classes: ['fas', 'fa-plus'] }];
        }
        this.headerinfo.setHeaderDisplay('Packages', this.breadcrumb, adminActions);
      }
    }
    finally{
      if(!this.embeded){
        this.headerinfo.pageLoadingDone(this);
      }
    }
  }

  hasPackages(){
    return this.modulePackages && this.modulePackages.length > 0;
  }

}
